import { h } from 'preact'
import { Block, Separator } from '../layout'
import { Select } from '../visual'

const compareByDisabled = (a, b) => {
  if (a.disabled && !b.disabled) return 1
  if (b.disabled && !a.disabled) return -1
  return a.value.toLowerCase().localeCompare(b.value.toLowerCase())
}

export default ({ filters, setFilter, parties, filterFunc, list }) => {
  const disabled = kv =>
    !filterFunc({ ...filters, ...kv, name: '' }, list).some(p => !p.hidden)
  return (
    <Block alt style={{ padding: '20px 0 10px 0' }}>
      <div
        style={{
          margin: '0 0 -20px -20px',
          textAlign: 'center',
        }}
      >
        <Select
          list={[
            { key: '', value: 'Všichni politici' },
            {
              key: 'MOP',
              value: 'Poslanec',
              disabled: disabled({ type: 'MOP' }),
            },
            {
              key: 'senator',
              value: 'Senátor',
              disabled: disabled({ type: 'senator' }),
            },
          ]}
          value={filters.type}
          onChange={setFilter('type')}
        />
        <Select
          list={[{ key: '', value: 'Všechny strany / kluby' }].concat(
            parties
              .map(v => ({
                key: v,
                value: v,
                disabled: disabled({ party: v }),
              }))
              .sort(compareByDisabled),
          )}
          value={filters.party}
          onChange={setFilter('party')}
        />
        <Select
          list={[{ key: '', value: 'Všechny kraje' }].concat(
            [
              { key: 'Praha', value: 'Praha' },
              { key: 'Jihočeský kraj', value: 'Jihočeský kraj' },
              { key: 'Jihomoravský kraj', value: 'Jihomoravský kraj' },
              { key: 'Karlovarský kraj', value: 'Karlovarský kraj' },
              { key: 'Vysočina', value: 'Vysočina' },
              {
                key: 'Královéhradecký kraj',
                value: 'Královéhradecký kraj',
              },
              { key: 'Liberecký kraj', value: 'Liberecký kraj' },
              {
                key: 'Moravskoslezský kraj',
                value: 'Moravskoslezský kraj',
              },
              { key: 'Olomoucký kraj', value: 'Olomoucký kraj' },
              { key: 'Pardubický kraj', value: 'Pardubický kraj' },
              { key: 'Plzeňský kraj', value: 'Plzeňský kraj' },
              { key: 'Středočeský kraj', value: 'Středočeský kraj' },
              { key: 'Ústecký kraj', value: 'Ústecký kraj' },
              { key: 'Zlínský kraj', value: 'Zlínský kraj' },
            ]
              .map(v => ({
                ...v,
                disabled: disabled({ region: v.value }),
              }))
              .sort(compareByDisabled),
          )}
          value={filters.region}
          onChange={setFilter('region')}
        />
      </div>

      <div>
        <Separator packed>nebo vyhledejte konkrétního politika</Separator>

        <div>
          <form
            className="std form-filter alt-2"
            onSubmit={evt => evt.preventDefault()}
          >
            <div className="cell-set ib">
              <div className="cell">
                <input
                  type="text"
                  name="name"
                  className="text"
                  placeholder="Zadejte jméno politika"
                  value={filters.name}
                  onInput={e => setFilter('name')(e.target.value)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </Block>
  )
}



// WEBPACK FOOTER //
// ./components/PoliticianList/PoliticianListFilter.js